(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5542],{

/***/ 93284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/is-element/is-element.js
var is_element = __webpack_require__(24241);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Breadcrumbs/Breadcrumbs.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  root: {
    display: "flex",
    alignItems: "center"
  },
  breadcrumb: {
    lineHeight: 1,
    whiteSpace: "nowrap",
    WebkitTapHighlightColor: "transparent"
  },
  separator: {
    marginLeft: theme.spacing.xs,
    marginRight: theme.spacing.xs,
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

/* harmony default export */ var Breadcrumbs_styles = (useStyles);
//# sourceMappingURL=Breadcrumbs.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Breadcrumbs/Breadcrumbs.js







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  separator: "/"
};
const Breadcrumbs = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Breadcrumbs", defaultProps, props), { className, children, separator, classNames, styles, unstyled } = _a, others = __objRest(_a, ["className", "children", "separator", "classNames", "styles", "unstyled"]);
  const { classes, cx } = Breadcrumbs_styles(null, { classNames, styles, unstyled, name: "Breadcrumbs" });
  const items = react.Children.toArray(children).reduce((acc, child, index, array) => {
    var _a2;
    const item = (0,is_element/* isElement */.k)(child) ? react.cloneElement(child, {
      className: cx(classes.breadcrumb, (_a2 = child.props) == null ? void 0 : _a2.className),
      key: index
    }) : /* @__PURE__ */ react.createElement("div", {
      className: classes.breadcrumb,
      key: index
    }, child);
    acc.push(item);
    if (index !== array.length - 1) {
      acc.push(/* @__PURE__ */ react.createElement(Text/* Text */.x, {
        size: "sm",
        className: classes.separator,
        key: `separator-${index}`
      }, separator));
    }
    return acc;
  }, []);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), items);
});
Breadcrumbs.displayName = "@mantine/core/Breadcrumbs";


//# sourceMappingURL=Breadcrumbs.js.map


/***/ }),

/***/ 89814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ SimpleGrid; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/SimpleGrid/get-sorted-breakpoints/get-sorted-breakpoints.js
function getSortedBreakpoints(theme, breakpoints) {
  if (breakpoints.length === 0) {
    return breakpoints;
  }
  const property = "maxWidth" in breakpoints[0] ? "maxWidth" : "minWidth";
  const sorted = [...breakpoints].sort((a, b) => theme.fn.size({ size: b[property], sizes: theme.breakpoints }) - theme.fn.size({ size: a[property], sizes: theme.breakpoints }));
  return property === "minWidth" ? sorted.reverse() : sorted;
}


//# sourceMappingURL=get-sorted-breakpoints.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.styles.js



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var useStyles = (0,create_styles/* createStyles */.k)((theme, { spacing, breakpoints, cols, verticalSpacing }) => {
  const hasVerticalSpacing = verticalSpacing != null;
  const gridBreakpoints = getSortedBreakpoints(theme, breakpoints).reduce((acc, breakpoint) => {
    const property = "maxWidth" in breakpoint ? "max-width" : "min-width";
    const breakpointSize = theme.fn.size({
      size: property === "max-width" ? breakpoint.maxWidth : breakpoint.minWidth,
      sizes: theme.breakpoints
    });
    acc[`@media (${property}: ${breakpointSize - (property === "max-width" ? 1 : 0)}px)`] = {
      gridTemplateColumns: `repeat(${breakpoint.cols}, minmax(0, 1fr))`,
      gap: `${theme.fn.size({
        size: breakpoint.verticalSpacing || (hasVerticalSpacing ? verticalSpacing : spacing),
        sizes: theme.spacing
      })}px ${theme.fn.size({
        size: breakpoint.spacing || spacing,
        sizes: theme.spacing
      })}px`
    };
    return acc;
  }, {});
  return {
    root: __spreadValues({
      boxSizing: "border-box",
      display: "grid",
      gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
      gap: `${theme.fn.size({
        size: hasVerticalSpacing ? verticalSpacing : spacing,
        sizes: theme.spacing
      })}px ${theme.fn.size({
        size: spacing,
        sizes: theme.spacing
      })}px`
    }, gridBreakpoints)
  };
});

/* harmony default export */ var SimpleGrid_styles = (useStyles);
//# sourceMappingURL=SimpleGrid.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js





var SimpleGrid_defProp = Object.defineProperty;
var SimpleGrid_getOwnPropSymbols = Object.getOwnPropertySymbols;
var SimpleGrid_hasOwnProp = Object.prototype.hasOwnProperty;
var SimpleGrid_propIsEnum = Object.prototype.propertyIsEnumerable;
var SimpleGrid_defNormalProp = (obj, key, value) => key in obj ? SimpleGrid_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var SimpleGrid_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (SimpleGrid_hasOwnProp.call(b, prop))
      SimpleGrid_defNormalProp(a, prop, b[prop]);
  if (SimpleGrid_getOwnPropSymbols)
    for (var prop of SimpleGrid_getOwnPropSymbols(b)) {
      if (SimpleGrid_propIsEnum.call(b, prop))
        SimpleGrid_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (SimpleGrid_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && SimpleGrid_getOwnPropSymbols)
    for (var prop of SimpleGrid_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && SimpleGrid_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  breakpoints: [],
  cols: 1,
  spacing: "md"
};
const SimpleGrid = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("SimpleGrid", defaultProps, props), { className, breakpoints, cols, spacing, verticalSpacing, children, unstyled } = _a, others = __objRest(_a, ["className", "breakpoints", "cols", "spacing", "verticalSpacing", "children", "unstyled"]);
  const { classes, cx } = SimpleGrid_styles({ breakpoints, cols, spacing, verticalSpacing }, { unstyled, name: "SimpleGrid" });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, SimpleGrid_spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), children);
});
SimpleGrid.displayName = "@mantine/core/SimpleGrid";


//# sourceMappingURL=SimpleGrid.js.map


/***/ }),

/***/ 46928:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user-profile",
      function () {
        return __webpack_require__(22978);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ UserProfile; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _common_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6559);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26679);
/* harmony import */ var _setup_flexbiz_api_provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34733);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93284);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19236);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62679);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95117);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _profileLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33713);









function UserProfile() {
    var trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var routes = [
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.manager.home,
            href: "/"
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.manager.title,
            href: "/user-profile"
        }, 
    ];
    var route = [
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.manager.info,
            href: "/user-profile/my-profile",
            dcr: trans === null || trans === void 0 ? void 0 : trans.profile.manager.info_dcr
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.manager.address,
            href: "/user-profile/address-book",
            dcr: trans === null || trans === void 0 ? void 0 : trans.profile.manager.address_dcr
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.manager.purchase,
            href: "/user-profile/purchased-return",
            dcr: trans === null || trans === void 0 ? void 0 : trans.profile.manager.purchase_dcr
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.manager.liked,
            href: "/user-profile/liked-product",
            dcr: trans === null || trans === void 0 ? void 0 : trans.profile.manager.liked_dcr
        }, 
    ];
    var context = (0,_setup_flexbiz_api_provider__WEBPACK_IMPORTED_MODULE_3__/* .useApiContext */ .Q)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    react__WEBPACK_IMPORTED_MODULE_6__.useEffect(function() {
        if (!localStorage.getItem("token")) {
            context.setProgressStatus(false);
            router.push({
                pathname: "/dang-nhap"
            });
        }
    }, [
        context
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                padding: "20px 0px"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Breadcrumbs */ .O, {
                    children: routes === null || routes === void 0 ? void 0 : routes.map(function(item, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                            scroll: false,
                            href: item.href,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Title */ .D, {
                    align: "center",
                    order: 5,
                    sx: {
                        padding: "20px 0px"
                    },
                    children: trans === null || trans === void 0 ? void 0 : trans.profile.manager.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid */ .r, {
                    children: route === null || route === void 0 ? void 0 : route.map(function(item, index) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid.Col */ .r.Col, {
                            xs: 6,
                            md: 4,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                scroll: false,
                                href: item.href,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
                                    sx: {
                                        width: "100%",
                                        minHeight: 150,
                                        height: "100%",
                                        border: "1px solid rgba(0,0,0,.125)",
                                        borderRadius: 5,
                                        padding: 20,
                                        cursor: "pointer",
                                        // background: "rgb(241, 241, 241)",
                                        background: "linear-gradient(#fff,#f0f0f0)"
                                    },
                                    variant: "gradient",
                                    gradient: {
                                        from: "indigo",
                                        to: "cyan"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .x, {
                                            align: "center",
                                            size: "lg",
                                            weight: 500,
                                            children: item === null || item === void 0 ? void 0 : item.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Text */ .x, {
                                            align: "center",
                                            size: "md",
                                            sx: {
                                                padding: 20
                                            },
                                            children: item.dcr
                                        })
                                    ]
                                })
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 33713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProfileLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _common_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6559);
/* harmony import */ var _common_Layout_Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3195);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26679);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93284);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62679);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89814);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(95117);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);









function ProfileLayout(param) {
    var children = param.children;
    // const size = useWindowSize();
    var trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var route = [
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.info,
            href: "/user-profile/my-profile"
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.address,
            href: "/user-profile/address-book"
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.purchase,
            href: "/user-profile/purchased-return"
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.liked,
            href: "/user-profile/liked-product"
        }, 
    ];
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().pathname;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_6__.useState([
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.home,
            href: "/"
        },
        {
            title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.title,
            href: "/user-profile"
        }, 
    ]), 2), routes = ref[0], setRoutes = ref[1];
    react__WEBPACK_IMPORTED_MODULE_6__.useEffect(function() {
        var state = [
            {
                title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.home,
                href: "/"
            },
            {
                title: trans === null || trans === void 0 ? void 0 : trans.profile.layout.title,
                href: "/user-profile"
            }, 
        ];
        route.map(function(item) {
            pathname.indexOf(item.href) >= 0 && state.push(item);
        });
        setRoutes(state);
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Layout_Container_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                padding: "20px 0px"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Breadcrumbs */ .O, {
                    children: routes === null || routes === void 0 ? void 0 : routes.map(function(item, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                            scroll: false,
                            href: item.href,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Grid */ .r, {
                    sx: {
                        padding: "30px 0px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Grid.Col */ .r.Col, {
                            xs: 3,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .SimpleGrid */ .M, {
                                cols: 1,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        scroll: false,
                                        href: "/user-profile",
                                        sx: {},
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            transform: "uppercase",
                                            weight: pathname === "/user-profile" ? 700 : 500,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: trans === null || trans === void 0 ? void 0 : trans.profile.layout.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        scroll: false,
                                        href: "/user-profile/my-profile",
                                        sx: {},
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            transform: "uppercase",
                                            weight: pathname.indexOf("/my-profile") >= 0 ? 700 : 500,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: trans === null || trans === void 0 ? void 0 : trans.profile.layout.info
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        scroll: false,
                                        href: "/user-profile/address-book",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            transform: "uppercase",
                                            weight: pathname.indexOf("/address-book") >= 0 ? 700 : 500,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: trans === null || trans === void 0 ? void 0 : trans.profile.layout.address
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        scroll: false,
                                        href: "/user-profile/purchased-return",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            transform: "uppercase",
                                            weight: pathname.indexOf("/purchased-return") >= 0 ? 700 : 500,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: trans === null || trans === void 0 ? void 0 : trans.profile.layout.purchase
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        scroll: false,
                                        href: "/user-profile/liked-product",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            transform: "uppercase",
                                            weight: pathname.indexOf("/liked-product") >= 0 ? 700 : 500,
                                            sx: {
                                                cursor: "pointer"
                                            },
                                            children: trans === null || trans === void 0 ? void 0 : trans.profile.layout.liked
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .Grid.Col */ .r.Col, {
                            xs: 9,
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};
ProfileLayout.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                    children: page
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Layout_Footer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(46928); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);